import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import {
  displayIdNumber,
  formatBirthdate,
  getFullName,
} from 'dashboard/components/ChecksTable/computeCheckMetadata/utils';
import { formatDate } from 'dashboard/lib/utils/formatters';
import { IdMrzDetection } from 'dashboard/models/check';
import { COUNTRIES, CountryCode } from 'lib/constants/locales';

export const computeIdMrzDetectionMetadata = (
  check: IdMrzDetection,
  hasPermissionVerificationGovIdNumberView: boolean,
): CheckMetadata => {
  const {
    sex,
    'expiration-date': expirationDate,
    'issuing-country': issuingCountry,
    'identification-number': identificationNumber,
    birthdate,
  } = check.metadata || {};

  return {
    metadata: createSimpleCheckMetadataArray([
      {
        label: 'Name',
        value: check.metadata && getFullName(check.metadata),
      },
      {
        label: 'Birthdate',
        value: formatBirthdate(birthdate),
      },
      {
        label: 'Sex',
        value: sex,
      },
      {
        label: 'Expiration Date',
        value: formatDate(expirationDate),
      },
      {
        label: 'Issuing Country',
        value: COUNTRIES[issuingCountry as CountryCode],
      },
      {
        label: 'Identification Number',
        value: displayIdNumber(
          identificationNumber || '',
          hasPermissionVerificationGovIdNumberView,
        ),
      },
    ]),
    hideIfVerificationPassed: false,
  };
};
